module.exports = __webpack_public_path__ + "img/ANTENNA PALMA LIME.bcc4fd6.svg";